import React from 'react';
import PropTypes from 'prop-types';

import styles from './ImageElement.module.less';

const ImageElement = ({
  element,
}) => {

  return (
    <section className={styles.vpDisplayImageContainer}>
      <img
        className={styles.vpImage}
        src={element.mediaUrl}
        alt=""
      />
    </section>
  );
}

ImageElement.propTypes = {
  element: PropTypes.object,
};

export default ImageElement;



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/ImageElement.jsx